import { render } from "./RenderOSQRTable.vue?vue&type=template&id=9cbf82c4"
import script from "./RenderOSQRTable.vue?vue&type=script&lang=js"
export * from "./RenderOSQRTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__